import _ from 'lodash'
import * as R from 'ramda'
import {
  getNameDescriptionTableColumn,
  getTimeTableColumn,
} from '@/utils/common/tableColumn'

import TagTableColumn from '@/sections/TagTableColumn'
import {
  getBudgetCycleTableColumn,
  getBillingTypeTableColumn,
  getBudgetAmountTableColumn,
  getBudgetResourceTypeTableColumn,
  getBudgetStatusTableColumn,
  getBudgetBrandTableColumn,
  getBudgetAccountTableColumn,
  getBudgetCloudProividerTableColumn,
  getBudgetRegionTableColumn,
  // getBudgetDomainTableColumn,
  getBudgetProjectTableColumn,
  getBudgetStartDateTableColumn,
  getBudgetEndDateTableColumn,
} from '../utils/columns'

export default {
  created () {
    this.columns = [
      getNameDescriptionTableColumn({
        onManager: this.onManager,
        hideField: true,
        slotCallback: row => {
          return (
            <side-page-trigger onTrigger={() => this.handleOpenSidepage(row)}>{ row.name }</side-page-trigger>
          )
        },
      }),
      getBudgetStatusTableColumn(),
      getBudgetCycleTableColumn(),
      getBillingTypeTableColumn(),
      getBudgetAmountTableColumn(),
      getBudgetStartDateTableColumn(),
      getBudgetEndDateTableColumn(),
      getTimeTableColumn({ field: 'created_at', title: this.$t('common.createdAt') }),
      getBudgetBrandTableColumn(),
      getBudgetAccountTableColumn(),
      getBudgetCloudProividerTableColumn(),
      getBudgetProjectTableColumn(),
      getBudgetRegionTableColumn(),
      getBudgetResourceTypeTableColumn(),
      {
        field: 'metadata',
        title: this.$t('table.title.tag'),
        width: 50,
        slots: {
          default: ({ row }, h) => {
            if (row.metadata) {
              return [
                h(TagTableColumn, {
                  props: {
                    row,
                    metadata: _.get(row, 'metadata') || {},
                    resource: 'server',
                    columns: () => this.columns,
                    tipName: this.$t('dictionary.server'),
                    customTitle: this.getMatchText(row),
                  },
                }),
              ]
            } else {
              return '-'
            }
          },
        },
      },
    ]
  },
  methods: {
    getMatchText (row) {
      if (!R.is(Boolean, row.match_all)) {
        return ''
      }
      return row.match_all ? this.$t('bill.text_283') : this.$t('bill.text_284')
    },
  },
}
